/* eslint-disable react-hooks/exhaustive-deps */
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import ReactGA from "react-ga";
import { useDispatch } from "react-redux";
import { updateAWS } from "services/s3";
import "./App.css";
import { getLocalUser } from "./main/shared/helpers";
import { authRoles } from "./navigation/route-config";
import AppRouter from "./navigation/router";
import { profileRequest } from "./services/auth-service";
import { LOG_IN } from "./store/actions";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import logger from "main/shared/logger";

const TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const dispatch = useDispatch();
  useEffect(() => {
    const initializeApp = async () => {
      let localUser = null;
      let localUserType = null;

      try {
        localUser = getLocalUser();
        localUserType = atob(localStorage.getItem("user_type"));
      } catch (e) {
        // ignore invalid local user
      }
      if (
        localUser !== null &&
        localUserType !== authRoles.buSubAdmin &&
        localUserType !== authRoles.buInspector
      ) {
        dispatch({
          type: LOG_IN,
          payload: localUser,
        });

        try {
          await updateAWS();
        } catch (error) {
          // AWS init failure is non-blocking
        }
        setIsLoading(false);
      } else if (localStorage.getItem("access_token")) {
        profileRequest()
          .then(async (res) => {
            try {
              await updateAWS();
            } catch (error) {
              // AWS init failure is non-blocking
            }
            dispatch({
              type: LOG_IN,
              payload: res.data,
            });
          })
          .catch((err) => {
            // If profile request fails, clear invalid token
            if (err.response?.status === 401) {
              localStorage.removeItem("access_token");
            }
          })
          .finally(() => {
            setIsLoading(false);
          });
      } else {
        setIsLoading(false);
      }
    };

    initializeApp();
  }, []);

  return isLoading ? (
    <Spinner animation="border" variant="success" className="app-spinner" />
  ) : (
    <AppRouter />
  );
}

export default App;

let isReloadingForSWUpdate = false;

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (!registration?.waiting) {
      return;
    }

    window.alert(
      "🚀 A new version of Scout is available.\n\nWe’ll reload the app now to keep everything up to date."
    );

    try {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });

      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (isReloadingForSWUpdate) {
          return;
        }
        isReloadingForSWUpdate = true;
        window.location.reload();
      });

      setTimeout(() => {
        if (!isReloadingForSWUpdate) {
          window.location.reload();
        }
      }, 3000);
    } catch (error) {
      logger.error("Error while applying service worker update:", error);
      window.location.reload();
    }
  },
  onError: (error) => {
    logger.error("❌ Service worker registration failed:", {
      error: error?.message || error,
      isSecureContext: window.isSecureContext,
      protocol: window.location.protocol,
      hostname: window.location.hostname,
    });
  },
});
